import { TextInput, Typography } from "@strapi/design-system";
import { DatePicker } from "antd";
import dayjs from "dayjs";
import { t } from "i18next";
import { dateFormatList } from "../../util/helper";
import UploadFile from "../uploadFile";
import { useState, useEffect } from "react";

const ScienceMission = ({ data, setData }) => {
  const [fileList, setFileList] = useState([]);

  useEffect(() => {
    if (data?.attachment) {
      let item = null;

      if (data?.attachment?.id) {
        item = {
          uid: data?.attachment?.id,
          name: data?.attachment?.name,
          url: data?.attachment?.url,
          status: "done",
        };
      } else {
        let uploadedImages = [];
        if (localStorage.getItem("uploaded_images")) {
          uploadedImages = JSON.parse(localStorage.getItem("uploaded_images"));
        }

        if (uploadedImages.length > 0) {
          const img = uploadedImages.find((x) => x.id === data?.attachment);

          if (img) {
            item = {
              uid: img.id,
              name: img.name,
              url: img.url,
              status: "done",
            };
          } else {
            item = {
              uid: data?.attachment,
              name: data?.attachment?.name || "New File",
              url: data?.attachment?.url,
              status: "done",
            };
          }
        } else {
          item = {
            uid: data?.attachment,
            name: data?.attachment?.name || "New File",
            url: data?.attachment?.url,
            status: "done",
          };
        }
      }

      setFileList([item]);
    } else {
      setFileList([]);
    }
  }, [data?.attachment]);

  const handleSetName = (name) => {
    setData({ ...data, name });
  };

  const handleSetFundingAgency = (funding_agency) => {
    setData({ ...data, funding_agency });
  };

  const handleSetPosition = (position) => {
    setData({ ...data, position });
  };

  const handleSetUrl = (url) => {
    setData({ ...data, url });
  };

  const handleSetStartDate = (date, dateString) => {
    setData({ ...data, started_at: dayjs(date).format(dateFormatList[1]) });
  };

  const handleSetEndDate = (date, dateString) => {
    setData({ ...data, end_at: dayjs(date).format(dateFormatList[1]) });
  };

  const handleSetNote = (note) => {
    setData({ ...data, note });
  };

  const handleChangeAttachment = (resFile) => {
    setData({
      ...data,
      attachment: resFile?.id,
    });
  };

  const handleRemoveAttachment = (id) => {
    setData({
      ...data,
      attachment: null,
    });
  };

  return (
    <div>
      <TextInput
        label={t("str_task_name")}
        name="name"
        onChange={(e) => handleSetName(e.target.value)}
        value={data?.name || ""}
      />
      <br />
      <TextInput
        label={t("str_sponsor")}
        name="name"
        onChange={(e) => handleSetFundingAgency(e.target.value)}
        value={data?.funding_agency || ""}
      />
      <br />
      <Typography variant="pi" fontWeight="bold">
        {t("str_started_at")}
      </Typography>
      <br />
      <DatePicker
        value={data?.started_at ? dayjs(data?.started_at) : null}
        format={dateFormatList[0]}
        placeholder="dd/mm/yyyy"
        className="custom-date-picker"
        onChange={handleSetStartDate}
      />
      <br />
      <Typography variant="pi" fontWeight="bold">
        {t("str_end_at")}
      </Typography>
      <br />
      <DatePicker
        value={data?.end_at ? dayjs(data?.end_at) : null}
        format={dateFormatList[0]}
        placeholder="dd/mm/yyyy"
        className="custom-date-picker"
        onChange={handleSetEndDate}
      />
      <br />
      <TextInput
        label={t("str_role")}
        name="position"
        onChange={(e) => handleSetPosition(e.target.value)}
        value={data?.position || ""}
      />
      <br />
      <TextInput
        label={t("str_note")}
        name="note"
        onChange={(e) => handleSetNote(e.target.value)}
        value={data?.note || ""}
      />
      <br />
      <TextInput
        label={t("str_attach_proof")}
        name="url"
        onChange={(e) => handleSetUrl(e.target.value)}
        value={data?.url || ""}
      />
      <br />
      <Typography variant="pi" fontWeight="bold">
        {t("str_or_and")}
      </Typography>
      <br />
      <span className="subnotes">{t("str_only_pdf")}</span>
      <br />
      <UploadFile
        fileMimeType={["application/pdf"]}
        fileTypeAllowNames="pdf"
        handleUploadSuccess={handleChangeAttachment}
        fileList={fileList}
        handleRemoveFile={handleRemoveAttachment}
        accept="application/pdf"
      />
    </div>
  );
};

export default ScienceMission;
